"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (rawHexColor, amt) {
  var str = rawHexColor.slice(1);
  var hexColor = str.length > 3 ? str : str + str;

  var num = parseInt(hexColor, 16);

  var r = (num >> 16) + amt;
  if (r > 255) r = 255;else if (r < 0) r = 0;

  var b = (num >> 8 & 0x00FF) + amt;
  if (b > 255) b = 255;else if (b < 0) b = 0;

  var g = (num & 0x0000FF) + amt;
  if (g > 255) g = 255;else if (g < 0) g = 0;

  return "#" + (g | b << 8 | r << 16).toString(16);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/components/lib/utils/darkenColor.js
// module id = 403
// module chunks = 5